import { EDIT_FIELD } from "./constants";

/**
 * Move an item in an array from one index to another.
 */
const moveByIndex = (list, fromIndex, toIndex) => {
	if (fromIndex === toIndex) {
		return list.slice();
	}
	const copy = list.slice();
	const [item] = copy.splice(fromIndex, 1);
	copy.splice(toIndex, 0, item);
	return copy;
};

/**
 * Update an array when an item is repositioned, via the EDIT_FIELD.POSITION property.
 */
export const reorderContentItem = (contentItemArray, contentItemIndex, newPosition) => {
	contentItemArray.sort((a, b) => (a.Position ?? 0) - (b.Position ?? 0));
	const currentIndex = contentItemArray.findIndex((m) => m.Id === contentItemIndex);
	if (currentIndex < 0) {
		return contentItemArray;
	}
	const moved = moveByIndex(contentItemArray, currentIndex, newPosition);
	return moved.map((m, i) => ({
		...m,
		[EDIT_FIELD.POSITION]: i
	}));
};

/**
 * Undo an array's EDIT_FIELD.POSITION value back to the published values.
 */
export const resetContentItemOrder = (draftContentItemArray, publishedContentItemArray) => {
	return draftContentItemArray.sort((a, b) => (a.Position ?? 0) - (b.Position ?? 0)).map((m) => {
		const published = publishedContentItemArray.find((dm) => dm.Id === m.Id);
		return {
			...m,
			[EDIT_FIELD.POSITION]: published ? published.Position : m.Position
		};
	});
};
